<template>
  <v-row align="center">
    <v-col cols="3">
      <SelectEmpresa :multiple="true" @onChanged="company = $event" />
    </v-col>
    <v-col cols="2">
      <SelectPeriodo />
    </v-col>
    <v-col cols="2">
      <v-btn
        outlined
        color="blue darken-2"
        rounded
        dark
        depressed
        small
        @click="searchAll"
      >
        <v-icon left>
          mdi-magnify
        </v-icon>
        buscar
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
const moment = require("moment");
import firebase from "@/plugins/firebase";
import { Administrador } from "@/services/lead";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AppAnalytics",
  data() {
    return {
      withCompany: false,
      date_init: "",
      date_end: "",
      company: [],
      test: null,
      serviceLeadsAdministrador: new Administrador()
    };
  },

  components: {
    SelectPeriodo: () => import("../detailCompany/SelectPeriodo"),
    SelectEmpresa: () => import("@/components/select/SelectEmpresa")
  },

  methods: {
    ...mapActions("appAnalytics", [
      "setSession",
      "setConsorcio",
      "setFinanciamento",
      "setFilter",
      "setLeads",
      "setLeadFromFirestore"
    ]),

    searchAll() {
      const filter = this.getFilter;
      filter.withCompany = this.company.length > 0;
      filter.empresas = this.company;
      this.$emit("initScreen");
      this.initData();
    },

    async initData() {
      const callDate = this.getFilter;
      this.date_init = callDate.date[0];
      this.date_end = callDate.date[1];
      this.company = callDate.empresas;
      this.withCompany = callDate.withCompany;
      await this.callInitChart();
    },
    async callInitChart() {
      const a = await this._getSession();
      const b = await this._getFinancimento();
      const c = await this._getConsorcio();
      const d = await this._getLeads();
      Promise.all([a, b, c, d]).then(v => {
        this.$emit("initScreen");
      });
    },
    async _getSession() {
      return new Promise(async resolve => {
        const app_analytics = firebase
          .functions()
          .httpsCallable("app_analytics/session");
        await app_analytics({
          date_init: this.date_init,
          date_end: this.date_end,
          isCompany: this.withCompany,
          company: this.company
        })
          .then(result => {
            this.setSession(result.data);
            return resolve(true);
          })
          .catch(erro => {
            return resolve(true);
            console.log(erro);
          });
      });
    },

    async _getFinancimento() {
      return new Promise(async resolve => {
        const app_analytics = firebase
          .functions()
          .httpsCallable("app_analytics/financiamentoPeriodo");
        await app_analytics({
          date_init: this.date_init,
          date_end: this.date_end,
          isCompany: this.withCompany,
          company: this.company
        })
          .then(result => {
            this.setFinanciamento(result.data);
            return resolve(true);
          })
          .catch(erro => {
            return resolve(true);
            console.log(erro);
          });
      });
    },

    async _getLeads() {
      const response = await this.serviceLeadsAdministrador.getLeadsByDataCriacaoWithoutCompany(
        // this.company,
        this.date_init,
        this.date_end
      );

      var total_lead = await this.generateLeadForDate(response);
      var generateLeadForCompany = await this.generateLeadForCompany(response);

      return new Promise(async resolve => {
        const app_analytics = firebase
          .functions()
          .httpsCallable("app_analytics/leadsDate");
        await app_analytics({
          date_init: this.date_init,
          date_end: this.date_end,
          isCompany: this.withCompany,
          company: this.company
        })
          .then(result => {
            this.setLeadFromFirestore(generateLeadForCompany);
            this.setLeads(total_lead);
            return resolve(true);
          })
          .catch(erro => {
            return resolve(true);
            console.log(erro);
          });
      });
    },

    async generateLeadForDate(response) {
      var total_temp1 = response.length;
      var g2 = response.reduce((r, a) => {
        r[a.dataCriacao.toDate().toLocaleDateString()] = [
          ...(r[a.dataCriacao.toDate().toLocaleDateString()] || []),
          a
        ];
        return r;
      }, {});
      var total_lead = [];
      for (var prop in g2) {
        total_lead.push({
          percentual: parseFloat((g2[prop].length / total_temp1) * 100).toFixed(
            2
          ),
          periodo_format: prop,
          total_all: total_temp1,
          total_simulado: g2[prop].length
        });
      }

      return await total_lead;
    },

    async generateLeadForCompany(response) {
      var total_temp1 = response.length;
      var g2 = response.reduce((r, a) => {
        r[a.empresa] = [...(r[a.empresa] || []), a];
        return r;
      }, {});
      var total_lead = [];
      for (var prop in g2) {
        total_lead.push({
          percentual: parseFloat((g2[prop].length / total_temp1) * 100).toFixed(
            2
          ),
          empresa: prop,
          total_all: total_temp1,
          total_simulado: g2[prop].length
        });
      }
      return await total_lead;
    },

    async _getConsorcio() {
      return new Promise(async resolve => {
        const app_analytics = firebase
          .functions()
          .httpsCallable("app_analytics/consorcioPeriodo");
        await app_analytics({
          date_init: this.date_init,
          date_end: this.date_end,
          isCompany: this.withCompany,
          company: this.company
        })
          .then(result => {
            this.setConsorcio(result.data);
            return resolve(true);
          })
          .catch(erro => {
            return resolve(true);
            console.log(erro);
          });
      });
    }
  },
  computed: {
    ...mapGetters("appAnalytics", ["getFilter"])
  },
  watch: {
    getFilter(m, v) {
      this.$emit("initScreen");
      this.initData();
    }
  },
  created() {
    this.initData();
  },
  mounted() {}
};
</script>
